import { render } from "./SetJourneySetInfo.vue?vue&type=template&id=554cceb8&scoped=true"
import script from "./SetJourneySetInfo.vue?vue&type=script&lang=ts"
export * from "./SetJourneySetInfo.vue?vue&type=script&lang=ts"

import "./SetJourneySetInfo.vue?vue&type=style&index=0&id=554cceb8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-554cceb8"

export default script